import React from "react";
import SweetAlert from 'react-bootstrap-sweetalert';

export default (props) => {
  const {
    inputProps,
    onConfirm
  } = props;
  const { type, show, title, text } = inputProps;

  return (
    <SweetAlert
      style={{overflow:'unset'}}
      type={type}
      confirmBtnCssClass="alert-btn-confirm"
      showConfirm
      show={show}
      confirmBtnText="Продолжить"
      confirmBtnBsStyle="danger"
      title={title}
      onConfirm={() => onConfirm()}
    >
      <div>
        <span>
          {text}
        </span>
      </div>
    </SweetAlert>
  )
}


// WEBPACK FOOTER //
// ./src/components/MakeOrder/Modals/downloadErrorMessage.js